'use strict';

const _ = require('underscore');
const Backbone = require('dibs-backbone');
const SoaModel = require('../SoaModel');
const Price = SoaModel.extend();
const FinancialAmount = require('../FinancialAmount');

// graphql transforms all Y/N's into true/false
// make sure we can accomodate both
function isYes(prop) {
    return prop === 'Y' || prop === true;
}

_.extend(Price, {
    TYPE_NET: 'NET',
    TYPE_RETAIL: 'RETAIL',
    TYPE_SALE: 'WEEKLY_SALE',
    STATUS_ACTIVE: 'ACTIVE'
});

_.extend(Price.prototype, {
    relations: [
        {
            key: 'amount',
            relatedModel: FinancialAmount,
            type: Backbone.One
        }
    ],
    isSoldIndividually() {
        return isYes(this.get('pricePerPiece'));
    },
    isNegotiable() {
        return isYes(this.get('negotiable'));
    },
    shouldHidePrice() {
        return isYes(this.get('hidePrice'));
    },
    isActive: function () {
        return this.get('status') === Price.STATUS_ACTIVE;
    },
    isRetail: function () {
        return this.get('type') === Price.TYPE_RETAIL;
    },
    isSale: function () {
        return this.get('type') === Price.TYPE_SALE;
    }
});


module.exports = Price;



// WEBPACK FOOTER //
// ./~/bunsen/models/inventory/Price.es.js